import { ComponentType } from "react";
import AgentHome from "./versions/AgentHome/AgentHome";
import AgentHomeV4 from "./versions/AgentHomeV4/AgentHomeV4";
import ClassicHome from "./versions/ClassicHome/ClassicHome";
import HomePage from "./versions/HomePage/HomePage";

// The version → component map. To add a version: create its folder under
// versions/, add it here, and bump LATEST_HOME_VERSION in Helper/homeVersion.ts.
// Both helpers below take an ALREADY RESOLVED version — the one and only place
// a raw `config.v` turns into a version is the Config store's getHomeVersion().
const HOME_VERSIONS: Record<number, ComponentType> = {
  1: ClassicHome,
  2: HomePage,
  3: AgentHome,
  4: AgentHomeV4,
};

export const resolveHomeVersion = (version: number): ComponentType =>
  HOME_VERSIONS[version];

// The version-scoped CSS hook shared components (App shell, TabBar) opt into.
// v1/v2 intentionally get no class (they never had one).
export const homeVersionClass = (version: number): string =>
  version >= 3 ? `v${version}` : "";
